module.exports = __webpack_public_path__ + "static/media/Shellder_gaussian2.e32b81b4.png";